import { Receipt } from "./receipt.model";
import { constants } from "../utils/constants";
import { UserLogged } from "./user-logged.model";
import {
  Approved,
  Confirmed,
  Created,
  Deserted,
  Formalized,
  Pending,
  Rejected,
  RequestState,
  Accepted,
  Finalized,
  FinalizedP,

} from "./request-state.model";

export interface IRequestType {
  name: string;
  value: number;
}

export class RequestModel {
  id: string;
  number: number;
  ruc: string;
  companyName: string;
  amount: number;
  url: string;
  name: string;
  currency: string;
  type: IRequestType;
  responsible: string;
  totalRecords: number;
  date: Date;
  state: RequestState;
  receipts: Receipt[];
  paymentMethod: { code: number; name: string };

  constructor(request: {
    id?: string;
    number?: number;
    ruc?: string;
    companyName?: string;
    amount?: number;
    url?: string;
    name?: string;
    currency?: string;
    type: number;
    totalRecords?: number;
    date?: Date;
    stateCode?: number;
    responsible?: string;
    receipts?: Receipt[];
    paymentMethod?: number;
  }) {
    this.id = request.id;
    this.number = request.number;
    this.ruc = request.ruc;
    this.companyName = request.companyName;
    this.amount = request.amount;
    this.currency = request.currency;
    this.totalRecords = request.totalRecords;
    this.type = { value: request.type, name: this.getTypeName(request.type) };
    this.date = request.date || new Date();
    this.responsible = request.responsible;
    this.name = request.name;
    this.url = request.url;
    this.setConcreteState(request.stateCode);
    this.receipts = request.receipts || [];
    if (request.paymentMethod) {
      this.setPaymentMethod(request.paymentMethod);
    }
  }

  setPaymentMethod(code: number) {
    switch (code) {
      case constants.rules.codes.paymentMethods.cash.value:
        this.paymentMethod = {
          code,
          name: constants.rules.codes.paymentMethods.cash.name,
        };
        break;
      case constants.rules.codes.paymentMethods.cheque.value:
        this.paymentMethod = {
          code,
          name: constants.rules.codes.paymentMethods.cheque.name,
        };
        break;
      case constants.rules.codes.paymentMethods.transfer.value:
        this.paymentMethod = {
          code,
          name: constants.rules.codes.paymentMethods.transfer.name,
        };
        break;
    }
  }

  // State
  public transitionTo(newState: RequestState) {
    this.state = newState;
  }

  public canBeRejected(user: UserLogged): boolean {
    return this.state.canBeRejected(user);
  }

  public canBeApproved(user: UserLogged): boolean {
    return this.state.canBeApproved(user);
  }

  public canModifyReceipts(user: UserLogged): boolean {
    return this.state.canModifyReceipts(user);
  }

  public canSendReceipts(user: UserLogged): boolean {
    return this.state.canSendReceipts(this, user);
  }

  public canBeConfirmed(user: UserLogged): boolean {
    return this.state.canBeConfirmed(user);
  }

  public canBeAccepted(user: UserLogged): boolean {
    return this.state.canBeAccepted(user);
  }


  
  public addReceipt(receipt: Receipt) {
    this.receipts.push(receipt);
  }

  public deleteReceipt(receipt: Receipt) {
    this.receipts = this.receipts.filter((r) => r.id !== receipt.id);
  }

  public replaceReceipt(receipt: Receipt) {
    const index = this.receipts.findIndex((r) => r.id === receipt.id);
    if (index > -1) {
      this.receipts[index] = receipt;
    }
  }

  public isRRBB() {
    return this.type.value === constants.rules.codes.requestTypes.rrbb.value;
  }

  getTypeName(type: number): string {
    switch (+type) {
      case constants.rules.codes.requestTypes.rrbb.value:
        return constants.rules.codes.requestTypes.rrbb.name;
      case constants.rules.codes.requestTypes.cts.value:
        return constants.rules.codes.requestTypes.cts.name;
      case constants.rules.codes.requestTypes.paymentOfSalaries.value:
        return constants.rules.codes.requestTypes.paymentOfSalaries.name;
      default:
        return constants.rules.codes.requestTypes.paymentOfSalaries.name;
    }
  }

  private setConcreteState(number: number) {
    switch (number) {
      case constants.rules.codes.requestStates.created.value:
        this.state = new Created();
        break;
      case constants.rules.codes.requestStates.pending.value:
        this.state = new Pending();
        break;
      case constants.rules.codes.requestStates.approved.value:
        this.state = new Approved();
        break;
      case constants.rules.codes.requestStates.formalized.value:
        this.state = new Formalized();
        break;
      case constants.rules.codes.requestStates.rejected.value:
        this.state = new Rejected();
        break;
      case constants.rules.codes.requestStates.deserted.value:
        this.state = new Deserted();
        break;
      case constants.rules.codes.requestStates.confirmed.value:
        this.state = new Confirmed();
        break;
      case constants.rules.codes.requestStates.accepted.value:
        this.state = new Accepted();
        break;
      case constants.rules.codes.requestStates.finalized.value:
        this.state = new Finalized();
        break;
      case constants.rules.codes.requestStates.finalizedP.value:
        this.state = new FinalizedP();
        break;

        
      default:
        break;
    }
  }

  public getAmountInEmailFormat(): string {
    return this.currency
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toUpperCase() === "DOLARES"
      ? "US$ " + this.amount.toLocaleString()
      : "S/ " + this.amount.toLocaleString();
  }
}
